<template>
  <SpinnerComp v-if="loading" />
  <div v-else>
    <TableComp
      :data="{
        title: 'Ordenes de Compra',
        headers: [
          'ID Orden',
          'Cotización',
          'Uso',
          'Proveedor',
          'Vendedor',
          'Fecha',
          'Referencia',
          'Opciones',
        ],
        visibleColumnsMobile: [0, 1, 3, 5, 7],
      }"
      :rows="rows"
      :options="options"
      @option-click="handleOptionAction"
    />

    <DeleteComp
      v-if="isDeleteOpen"
      :isOpen="isDeleteOpen"
      :deleteMessage="deleteMessage"
      @close="closeDelete"
      @confirm="deleteCompra"
    />
  </div>
</template>

<script>
import TableComp from "@/components/TableComp.vue";
import DeleteComp from "@/components/DeleteComp.vue";
import SpinnerComp from "@/components/SpinnerComp.vue";
export default {
  components: {
    TableComp,
    DeleteComp,
    SpinnerComp,
  },
  data() {
    return {
      loading: false,
      isDeleteOpen: false,
      deleteMessage: "",
      rows: [],
      options: [
        {
          icon: "material-symbols-outlined picture_as_pdf",
          action: "pdf",
          color: "bg-red-500",
        },
        {
          icon: "material-symbols-outlined delete",
          action: "delete",
          color: "bg-red-500",
        },
      ],
    };
  },
  methods: {
    closeDelete() {
      this.isDeleteOpen = false;
    },
    handleOptionAction(action, row) {
      const actions = {
        pdf: () => {
          this.generatePdf(row.idOC);
        },
        delete: () => {
          this.deleteMessage = `¿Estás seguro de que deseas eliminar la orden de compra: ${row.idOC}?`;
          this.idOrden = row.idOC;
          this.isDeleteOpen = true;
        },
      };
      if (actions[action]) {
        actions[action]();
      }
    },
    getData() {
      this.loading = true;
      this.$axios
        .get("/getOrd")
        .then((response) => {
          this.rows = response.data.ordenesCompra.map((item) => ({
            idOC: item.idOC,
            idCotOC: item.idCotOC,
            usoOC: item.usoOC,
            proveedor: item.nombreProveedor,
            vendedor: item.nombreVendedor,
            fechaOC: item.fechaOC,
            referenciaOC: item.referenciaOC,
          }));
        })
        .catch((error) => {
          alert(error.response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteCompra() {
      this.$axios
        .delete("/deleteOrd", { params: { id: this.idOrden } })
        .then((response) => {
          this.closeDelete();
          alert(response.data.message);
          this.getData();
        })
        .catch((error) => {
          console.error("message", error.response);
          if (error.response.status === 403) {
            alert(error.response.data.message);
          }
        });
    },
    generatePdf(id) {
      this.$axios
        .get(`/generate-pdf-OC/${id}`, {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          const newTab = window.open(url, "_blank");
          if (
            !newTab ||
            newTab.closed ||
            typeof newTab.closed === "undefined"
          ) {
            const link = document.createElement("a");
            link.href = url;
            link.download = `archivo-${id}.pdf`;
            link.click();
            alert(
              "El PDF no pudo abrirse en una nueva ventana. Se descargará automáticamente."
            );
          }
        })
        .catch((error) => {
          alert(error.response?.data?.message || "Error al generar el PDF");
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
